import { ArrowUpRight, Waypoints } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { SectionCard } from "~/components/section-card";
import { Badge, Button } from "~/components/ui";
import type { RelatedCompoundEntity } from "~/features/entities/types";
import { v2Route } from "~/v2/routes";

interface EntityCompoundEntityCardProps {
  compoundEntity: RelatedCompoundEntity | null;
}

export function EntityCompoundEntityCard({ compoundEntity }: EntityCompoundEntityCardProps) {
  const { t } = useTranslation();

  return (
    <SectionCard icon={Waypoints} title={t("model.compoundEntity.modelName")}>
      {compoundEntity ? (
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="min-w-0 space-y-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-14-bold text-fg-1">{compoundEntity.displayName || compoundEntity.id}</span>
              <Badge tone="default">{compoundEntity.version}</Badge>
            </div>
            <p className="break-all text-12-regular tabular-nums text-fg-3">{compoundEntity.id}</p>
          </div>
          <Button type="button" variant="outline" size="sm" asChild>
            <Link
              to={v2Route.compoundEntities.detail.$buildPath({ params: { id: compoundEntity.id } })}
              aria-label={t("ui.detail")}
            >
              <span>{t("ui.detail")}</span>
              <ArrowUpRight />
            </Link>
          </Button>
        </div>
      ) : (
        <p className="text-[13px] text-fg-3">{t("feature.common.noData")}</p>
      )}
    </SectionCard>
  );
}
